// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "checkbox_wrapper-2hTt9";
var _3 = "checkbox_root-fPv1d";
var _4 = "checkbox_rootChecked-2DvS6";
export { _1 as "__esModule", _2 as "checkbox_wrapper", _3 as "checkbox_root", _4 as "checkbox_rootChecked" }
export default { "__esModule": _1, "checkbox_wrapper": _2, "checkbox_root": _3, "checkbox_rootChecked": _4 }
